
import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip
} from "recharts";
import { useTranslation } from "react-i18next";
import { ChartDataPoint } from "@/types/puttingResults";
import { getTestColor } from "./TestColorConfig";
import { translateExerciseName } from "@/utils/exerciseTranslations";

interface SeparateChartsProps {
  filteredTestTypes: string[];
  filteredChartData: Record<string, ChartDataPoint[]>;
  pointsDomain: [number, number];
}

const SeparateCharts: React.FC<SeparateChartsProps> = ({ 
  filteredTestTypes, 
  filteredChartData, 
  pointsDomain 
}) => {
  const { t } = useTranslation('common');

  return (
    <div className="space-y-6">
      {filteredTestTypes.map(testType => (
        <div key={testType} className="space-y-2">
          <h3 className="text-sm font-medium text-muted-foreground">
            {translateExerciseName(testType, t)}
          </h3>
          <div className="h-[180px] w-full">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart 
                data={filteredChartData[testType] || []}
                margin={{ top: 10, right: 30, left: 0, bottom: 10 }}
              >
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                <XAxis 
                  dataKey="date" 
                  tick={{ fontSize: 12 }}
                  tickMargin={8}
                />
                <YAxis 
                  orientation="left" 
                  domain={pointsDomain}
                  tick={{ fontSize: 12 }}
                  tickMargin={8}
                  width={30}
                  allowDecimals={false}
                />
                <Tooltip 
                  formatter={(value, name) => {
                    if (name === "points") return [`${value} pts`, "Points"];
                    return [value, name];
                  }}
                />
                <Line
                  type="monotone"
                  dataKey="points"
                  name="points"
                  stroke={getTestColor(testType)}
                  strokeWidth={2}
                  dot={{ strokeWidth: 2, r: 4, fill: getTestColor(testType) }}
                  activeDot={{ strokeWidth: 0, r: 6, fill: getTestColor(testType) }}
                  isAnimationActive={true}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SeparateCharts;
